var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseAndTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8687",
    "data-name": "Rectangle 8687",
    width: 17.402,
    height: 15.968,
    fill: "#0072ce"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Title_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Title_Complete",
    "data-name": "Title Complete",
    clipPath: "url(#clip-Title_Complete)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11745",
    "data-name": "Group 11745",
    transform: "translate(0.299 1.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11744",
    "data-name": "Group 11744",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22160",
    "data-name": "Path 22160",
    d: "M15.567,15.968H1.836a.407.407,0,0,0-.078-.028A1.99,1.99,0,0,1,0,13.919Q0,7.979,0,2.04a2.109,2.109,0,0,1,.053-.488A1.986,1.986,0,0,1,2.032,0c1.58,0,3.161,0,4.741,0q4.282,0,8.565,0a1.95,1.95,0,0,1,1.807,1.032,4.464,4.464,0,0,1,.258.693V14.235c-.012.036-.027.072-.036.109a1.977,1.977,0,0,1-1.311,1.5,4.69,4.69,0,0,1-.489.124m.748-12.328H1.088v.144q0,5.063,0,10.126a1.107,1.107,0,0,0,.017.219.924.924,0,0,0,.994.741H15.266a.931.931,0,0,0,1.049-1.043q0-5,0-9.99v-.2M1.09,2.532H16.308a5.753,5.753,0,0,0,0-.651.915.915,0,0,0-1-.792H2.105a1.652,1.652,0,0,0-.27.02.894.894,0,0,0-.742.815c-.012.2,0,.4,0,.607",
    transform: "translate(0 -0.001)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22161",
    "data-name": "Path 22161",
    d: "M64.919,171.546c0,.183,0,.353,0,.522a.543.543,0,1,1-1.086,0q-.006-.527,0-1.053a.538.538,0,0,1,.57-.562q3.049,0,6.1,0a.536.536,0,0,1,.577.57q.006.518,0,1.036a.542.542,0,0,1-.53.568.549.549,0,0,1-.555-.563c-.005-.168,0-.337,0-.514H68.016v5.064c.1,0,.206,0,.311,0a.545.545,0,0,1,.575.558.536.536,0,0,1-.583.528q-.866,0-1.733,0a.544.544,0,0,1-.58-.534.55.55,0,0,1,.584-.552c.1,0,.2,0,.314,0v-5.063Z",
    transform: "translate(-61.656 -164.643)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22162",
    "data-name": "Path 22162",
    d: "M321.574,171.536c-.521,0-1.042,0-1.563,0a.547.547,0,1,1,0-1.087h3.143a.546.546,0,1,1,0,1.087c-.527,0-1.053,0-1.58,0",
    transform: "translate(-308.529 -164.644)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22163",
    "data-name": "Path 22163",
    d: "M321.564,256.614c-.521,0-1.042,0-1.563,0a.546.546,0,1,1,0-1.086q1.58,0,3.16,0a.556.556,0,0,1,.587.459.536.536,0,0,1-.351.592.854.854,0,0,1-.267.035c-.521,0-1.042,0-1.563,0",
    transform: "translate(-308.524 -246.824)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22164",
    "data-name": "Path 22164",
    d: "M321.592,340.877c.544,0,1.087,0,1.631,0a.537.537,0,0,1,.248,1.007.719.719,0,0,1-.309.074q-1.588.008-3.176,0a.549.549,0,0,1-.586-.55.544.544,0,0,1,.6-.535c.532,0,1.064,0,1.6,0Z",
    transform: "translate(-308.523 -329.267)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseAndTitle);
export default __webpack_public_path__ + "static/media/License_And_Title.de40a44830b0a14bef73896aac9fa233.svg";
export { ForwardRef as ReactComponent };